import { EventEmitter } from 'ahooks/lib/useEventEmitter';
import { PortkeyDidV1, PortkeyDid } from './index';
export class Store {
    async getItem(key) {
        return localStorage.getItem(key);
    }
    async setItem(key, value) {
        return localStorage.setItem(key, value);
    }
    async removeItem(key) {
        return localStorage.removeItem(key);
    }
}
let globalConfig;
export const event$ = new EventEmitter();
export function setGlobalConfig(config) {
    globalConfig = config;
    if (config.portkey.useLocalStorage) {
        config.portkey.storageMethod = new Store();
    }
    // v1 v2 set config at the same time
    PortkeyDidV1.ConfigProvider.setGlobalConfig(config.portkey);
    PortkeyDid.ConfigProvider.setGlobalConfig({
        ...config.portkey,
        ...config.portkeyV2,
    });
}
export function getConfig() {
    return globalConfig;
}
